import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { useFormikContext } from "formik";
import ShippingMethod from "./ShippingMethod";
import {
    selectAllRegistration,
    updateRegistrationShippingMethod,
    updateRegistrationTotals,
} from "../../../redux/slices/registrationSlice";
import { selectAllProductSettings } from "../../../redux/slices/productSettingsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";

const ConnectedShippingMethod = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const { values, setFieldValue } = useFormikContext();
    const { storeCart = [] } = useSelector(selectAllRegistration);
    const { Shipping_Method = "", Shipping_Address_Use_Mailing = true } =
        values;
    const { offerShipping = false, shipping_methods = [] } = useSelector(
        selectAllProductSettings,
    );

    const { currency, defaultCountry } = useSelector(selectAllFormSettings);

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );

    const {
        options: { shippingMethodLabel = "Shipping" },
    } = control;

    const displayShippingMethod = offerShipping && shipping_methods.length > 0;

    const shippingMethodProps = {
        currency,
        defaultCountry,
        displayShippingMethod,
        shippingMethodLabel,
        Shipping_Address_Use_Mailing,
        Shipping_Method,
        shipping_methods,
        setFieldValue,
        storeCart,
        // Actions
        updateRegistrationShippingMethod,
        updateRegistrationTotals,
    };
    return <ShippingMethod {...shippingMethodProps} />;
};

ConnectedShippingMethod.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedShippingMethod;
